import { APP_PREFIX_PATH } from '@constants/common';
import { useAppDispatch } from '@hooks/generic';
import { Box } from '@mui/material';
import { HighlightedNews } from '@news/routes/NewsOverview/HighlightedNews';
import { NewsList } from '@news/routes/NewsOverview/NewsList';
import { setBreadcrumbs } from '@store/breadcrumbSlice';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';

export const NewsOverview = () => {
    const intl = useIntl();
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(
            setBreadcrumbs([
                { label: intl.formatMessage({ id: 'news', defaultMessage: 'News' }), to: APP_PREFIX_PATH + '/news' },
            ])
        );
    }, [dispatch, intl]);

    return (
        <>
            <title>
                {intl.formatMessage(
                    { id: 'news.browserTitle', defaultMessage: '{brand} - News' },
                    { brand: 'Victron Professional' }
                )}
            </title>
            <Box px={{ xs: 2, md: 4 }}>
                <HighlightedNews />
            </Box>
            <NewsList />
        </>
    );
};
